"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
import { Component, PropSync, Vue } from "vue-property-decorator";
import UiDialog from "../../../components/dialog/UiDialog.vue";
import { UiDialogController } from "@/components/dialog/UiDialog.vue";
import CardDataItem from "@/views/costItems/components/CardDataItem.vue";
import { PaymentController } from "@/service/newProdect";
let PaymentNewVDCardDialog = class extends Vue {
  constructor() {
    super(...arguments);
    this.name = "PaymentNewVDCardDialog";
    this.carddialog = new UiDialogController();
  }
  close() {
    var _a;
    if (this._options.selected.paymentVdcard === null) {
      if (((_a = this._options.selected.categorys) == null ? void 0 : _a.payment[0]) !== "vdcard") {
        if (this._options.selected.categorys.payment.includes("alipay")) {
          this._options.selected.paymentType = "alipay";
          this.$emit("paymentChange");
        } else {
          this._options.selected.paymentType = this._options.selected.categorys.payment[0];
          this.$emit("paymentChange");
        }
      } else {
        this._options.selected.paymentType = this._options.selected.categorys.payment[1];
        this.$emit("paymentChange");
      }
    }
    this.carddialog.visible = false;
  }
  paymentChange() {
    if (this._options.selected.paymentVdcard !== null) {
      this._options.selected.paymentType = "vdcard";
    }
    this.$emit("paymentChange");
  }
  open() {
    this.carddialog.visible = true;
  }
};
__decorateClass([
  PropSync("options", {
    default: function() {
      return new PaymentController();
    }
  })
], PaymentNewVDCardDialog.prototype, "_options", 2);
__decorateClass([
  PropSync("paymentCards", { default: function() {
    return [];
  } })
], PaymentNewVDCardDialog.prototype, "_paymentCards", 2);
PaymentNewVDCardDialog = __decorateClass([
  Component(
    {
      components: {
        CardDataItem,
        UiDialog
      }
    }
  )
], PaymentNewVDCardDialog);
export {
  PaymentNewVDCardDialog as default
};
